import axios from 'axios';

// Add a global interceptor to attach the JWT token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Get all users
export const getUsers = async () => {
  const response = await axios.get(`${API_URL}/users`);
  return response.data;
};

// Get a single user
export const getUser = async (id) => {
  const response = await axios.get(`${API_URL}/users/${id}`);
  return response.data;
};

// Create a new user
export const createUser = async (userData) => {
  const response = await axios.post(`${API_URL}/users`, userData);
  return response.data;
};

// Update a user
export const updateUser = async (id, userData) => {
  const response = await axios.put(`${API_URL}/users/${id}`, userData);
  return response.data;
};

// Delete a user
export const deleteUser = async (id) => {
  const response = await axios.delete(`${API_URL}/users/${id}`);
  return response.data;
};

// Get user's tenant
export const getUserTenant = async (id) => {
  const response = await axios.get(`${API_URL}/users/${id}/tenant`);
  return response.data;
};

// Update user's tenant
export const updateUserTenant = async (id, tenantId) => {
  const response = await axios.put(`${API_URL}/users/${id}/tenant`, { tenantId });
  return response.data;
};

// Get user's role
export const getUserRole = async (id) => {
  const response = await axios.get(`${API_URL}/users/${id}/role`);
  return response.data;
};

// Update user's role
export const updateUserRole = async (id, role) => {
  const response = await axios.put(`${API_URL}/users/${id}/role`, { role });
  return response.data;
}; 
